import _bundle from '../../core/core--bundles';
import {gridExport} from '../project-review/all';

const $window = $('#cashForecast');
const $commentWindow = $('#invoiceComments');
let allCompanies = false;

export default function () {
    loadTab('Branch Forecasting');

    setupTabs();
    exportOptions();

    _bundle.add({
        name: 'Cash Collection: Change Tabs',
        event: ['on:TabChange'],
        fn() {
            // Set All Companies Flag
            allCompanies = $('.menu-topbar__link.--active').text() === 'Full Company';
            loadTab();
        }
    });

    _bundle.add({
        name: 'Cash Collection: Modal Loaded',
        event: ['on:UiUpdate'],
        fn() {
            saveInvoiceAssignment();
        }
    });
}
const setupTabs = () => {
    const tabBase = $('a.menu-topbar__link');
    tabBase.click(function (e) {
        const that = $(this);
        const parents = tabBase.parent();
        const thoseParents = that.parent();
        tabBase.removeClass('--active');
        tabBase.prop('disabled', true);
        parents.removeClass('--active');
        that.addClass('--active');
        thoseParents.addClass('--active');
        $(this).trigger('onTabChange');
    });
}
const loadTab = () => {
    createCashGrid();
    createTotalsGrid();
    scrollBackToTop();
    populateCashReceivedGrid();
}

function setupCommentSave() {
    $(document).unbind('Loaded:InvoiceWindow');
    $(document).bind('Loaded:InvoiceWindow', function(){
        console.debug('Setup Comment Save...');
        setTimeout(function () {
            const commentWindow = this;
            const btns = $('button.saveComment');
            console.debug('btns => ', btns);
            btns.show();
            btns.click(function (e) {
                console.debug('Clicked...');
                btns.hide();
                const that = $(this);
                const data = that.closest('form').serialize();
                console.debug('data => ', data);
                $.post({
                    url: '/Account/Finance/CashInvoiceSaveComment',
                    data,
                    success(r) {
                        if (r) {
                            $('#invoiceComments').data('kendoWindow').open();
                            // re attach button events
                            setupCommentSave();
                        }
                    }
                });
            });
        }, 1000)
    })
}

const setWindowData = () => {
    const $cells = $('td [data-kendoWindow]');

    if ($cells.length) {
        // Unbind click events to prevent duplicate running
        $cells.unbind('click');

        // Attach Event to add Window information;
        $cells.on('click', function () {
            const $self = $(this);
            const projectId = $self.data('project-id');
            const weekId = $self.data('week-id');
            const readOnly = $self.data('read-only');
            $window.data('project-id', projectId);
            $commentWindow.data('project-id', projectId);
            $window.data('week-id', weekId);
            $commentWindow.data('week-id', weekId);
            $commentWindow.data('read-only', readOnly);
            $commentWindow.data('kendoWindow').bind('activate', setupCommentSave);
        });
        // ReRun Kendo information
        $(document).trigger('on:PageUpdate');
    }
}

const contractTemplate = (dataItem) => {
    const isService = dataItem.invType === 'Work Order/Agreement';
    const text = isService ? `${dataItem.customerNum} - ${dataItem.customerName}` : dataItem.Contract;
    return `<span>${text}</span>
    <span ${isService ? 'hidden' : ''}
        data-role="contractInfoButton"
        data-is-service="${isService}"
        data-projectManager-fullName="${dataItem.pmName}"
        data-projectManager-firstName="${dataItem.pmFirst}"
        data-projectManager-lastName="${dataItem.pmLast}"
        data-customer-number="${dataItem.customerNum}"
        data-customer-name="${dataItem.customerName}"
        class="k-icon k-i-info"></span>`;
}

function addTooltips() {
    $('[data-role="contractInfoButton"]').each(function () {
        const that = $(this);
        $(that).kendoTooltip({
            position: 'right',
            showOn: 'mouseenter',
            autoHide: 'true',
            content() {
                const ttd = that.data();
                let pmText = `${ttd.projectmanagerFullname}`;
                let custText = `${ttd.customerNumber} - ${ttd.customerName}`;
                if (pmText === 'undefined' || pmText === null) {
                    pmText = 'Not selected';
                }
                if (ttd.customerNumber === 'undefined' || ttd.customerNumber === null) {
                    custText = 'Not selected';
                }
                const pm = `<div class="t-bold" style="width: 100%;">Project Manager:</div> ${pmText}`;
                const cs = `<div class="t-bold" style="width: 100%;">Customer:</div> ${custText}`;
                return ttd.isService ?
                    `<div>
                    ${pm}
                 </div>` :
                    `<div>
                   ${pm}
                   ${cs}
                 </div>`;
            }
        });
    });
}

function removeFilter(filters, filter, checkValue = false) {
    const fi = filters.filters.findIndex((f) => {
        return f.field === filter.field && f.operator === filter.operator && (checkValue ? filter.value === f.value : true)
    });
    if (fi >= 0) filters.filters.splice(fi, 1);
    return fi >= 0;
}

function setFilter(filters, newFilter) {
    removeFilter(filters, newFilter);
    filters.filters.push(newFilter);
}

function padValues(collection, char) {
    if (!(collection && char)) return;
    let c = [];
    collection.forEach(
        t => {
            c.push(`${char}${t}${char}`);
        });
    return c;
}

function addFilter(currentFilter, addFilter) {
    const fi = currentFilter.filters.findIndex((f) => {
        return f.forField === addFilter.forField;
    });
    if (fi >= 0) currentFilter.filters.splice(fi, 1);
    if (addFilter.filters.length) {
        currentFilter.filters.push(addFilter);
    }
}

function addOrFilter(currentFilter, fieldName, filterValues, operator = 'eq') {
    const filter = {
        filters: [],
        logic: 'or',
        forField: fieldName
    }
    addFilter(currentFilter, filter);
    const fi = currentFilter.filters.findIndex((f) => {
        return f.forField === filter.forField;
    });
    if (fi >= 0) currentFilter.filters.splice(fi, 1);
    if (filterValues.length) {
        filterValues.forEach(df => {
            filter.filters.push({field: filter.forField, operator, value: df});
        });
        currentFilter.filters.push(filter);
    }
}

function applyExtraFilters(e) {
    const $cashGrid = allCompanies ? $('.grid.all-cash-grid').data('kendoGrid') : $('.grid.cash-grid').data('kendoGrid');
    const currentFilter = $cashGrid.dataSource.filter() ?? {filters: [], logic: 'and'};
    const typeValue = $('#typeFilter').data('kendoDropDownList').value();
    const deptValues = $('#deptFilter').data('kendoMultiSelect').value();
    const pmValues = $('#pmFilter').data('kendoMultiSelect').value();
    const custValues = $('#customerFilter').data('kendoMultiSelect').value();

    const typeFilter = {
        field: 'invType',
        operator: 'eq',
        value: typeValue
    };
    if (typeValue !== 'All') {
        setFilter(currentFilter, typeFilter);
    } else {
        removeFilter(currentFilter, typeFilter);
    }

    const jobOrSrvcFilter = {
        filters: [],
        logic: 'or',
        forField: 'jsID'
    }
    if (deptValues.length && deptValues[0] !== '') {
        addOrFilter(jobOrSrvcFilter, 'jobDeptID', deptValues);
        addOrFilter(jobOrSrvcFilter, 'servCtrID', padValues(deptValues, '|'), 'contains');
        addFilter(currentFilter, jobOrSrvcFilter);
    } else {
        removeFilter(jobOrSrvcFilter);
    }

    addOrFilter(currentFilter, 'pmID', pmValues);
    addOrFilter(currentFilter, 'customerNum', custValues);

    $cashGrid.dataSource.filter(currentFilter);

}

function createCustomerList(data) {
    const customerData = [];
    data.forEach(function (row) {
        const customer = {
            name: row.customerName,
            id: row.customerNum
        };
        if (customer.id == null || customerData.find(customerToFind => customerToFind.id === customer.id)) return;
        customerData.push(customer);
    });
    customerData.sort(function (a, b) {
        const customerA = a?.name?.toLowerCase();
        const customerB = b?.name?.toLowerCase();
        if (customerA === customerB) return 0;
        return customerA > customerB ? 1 : -1;
    });
    return customerData;
}

function bindToSource(e) {
    if (e.type !== 'read' || e.response == undefined) return;
    const custEle = $('#customerFilter').data('kendoMultiSelect');
    custEle.setDataSource(new kendo.data.DataSource({
        data: createCustomerList(e.response)
    }));
}

// had to use ids, using classes resulted in the kendo data being 'lost' when searching in the future
function createExtraFilters(company) {
    const typeOptions = [{text: 'All', value: 'All'},
        {text: 'Contracts', value: 'Project'},
        {text: 'Work Orders/Agreements', value: 'Work Order/Agreement'}];

    const typeEle = $('#typeFilter');
    if (typeEle.data('kendoDropDownList') === undefined) {
        typeEle.kendoDropDownList({
            dataTextField: 'text',
            dataValueField: 'value',
            dataSource: {
                data: typeOptions
            }
        });
    }

    const parameterMap = (d, t) => {
        const map = {};
        map.company = company;
        return $.extend(map, d);
    }

    const deptEle = $('#deptFilter');
    if (deptEle.data('kendoMultiSelect') === undefined) {
        deptEle.kendoMultiSelect({
            placeholder: 'Select Job Departments...',
            dataTextField: 'description',
            dataValueField: 'id',
            autoBind: true,
            dataSource: {
                transport: {
                    read: {
                        dataType: 'json',
                        type: 'POST',
                        url: '/Finance/CashForecasting/JobDepartments'
                    },
                    parameterMap
                }
            }
        });
    }
    const pmEle = $('#pmFilter');
    if (pmEle.data('kendoMultiSelect') === undefined) {
        pmEle.kendoMultiSelect({
            placeholder: 'Select Project Managers...',
            dataTextField: 'name',
            dataValueField: 'id',
            autoBind: true,
            dataSource: {
                transport: {
                    read: {
                        dataType: 'json',
                        type: 'POST',
                        url: '/Finance/CashForecasting/ProjectManagers'
                    },
                    parameterMap
                }
            }
        });
    }

    const custEle = $('#customerFilter');
    if (custEle.data('kendoMultiSelect') === undefined) {
        custEle.kendoMultiSelect({
            placeholder: 'Select Customers...',
            dataTextField: 'name',
            dataValueField: 'id',
            autoBind: true,
            dataSource: {
                data: []
            }
        });
    }

    const applyFilters = $('#applyGridFilters');
    if ((applyFilters.data('bound') ?? false) === false) {
        applyFilters.click(applyExtraFilters);
        applyFilters.data('bound', true);
    }

}

const createCashGrid = () => {
    const $cashGrid = allCompanies ? $('.grid.all-cash-grid') : $('.grid.cash-grid');
    const company = $cashGrid.data('company');
    let columns = [{
        field: 'row',
        title: 'Row',
        width: 60,
        headerAttributes: {style: 'white-space: normal'},
        filterable: false,
        sortable: {
            mode: 'single',
            allowUnsort: true
        }
    }];

    // If grid already created dont load again.
    if ($cashGrid.data('kendoGrid')) return;
    createExtraFilters(company);

    if (allCompanies) {
        columns.push({
            field: 'company',
            title: 'Branch',
            headerAttributes: {style: 'white-space: normal'},
            width: 75,
            filterable: true,
            sortable: true
        });
    }

    columns = columns.concat([
        {
            field: 'Contract',
            title: 'Contract/ Customer #',
            template(dataItem) {
                const iBtn = $(document.createElement('span'));
                iBtn.addClass('k-icon k-i-info');
                iBtn.data('role', 'contractInfo');
                iBtn.data('invoice-type', dataItem.invType);
                iBtn.data('projectManager-fullName', dataItem.pmName);
                iBtn.data('projectManager-firstName', dataItem.pmFirst);
                iBtn.data('projectManager-lastName', dataItem.pmLast);
                iBtn.data('customer-number', dataItem.customerNum);
                iBtn.data('customer-name', dataItem.customerName);
                return contractTemplate(dataItem);
            },
            headerAttributes: {style: 'white-space: normal'},
            filterable: true,
            sortable: true
        },
        {
            field: 'arAge0_30',
            title: 'Current AR (0-30 days)',
            template(dataItem) {
                return kendoWindowTemplate(dataItem, 'arAge0_30', true);
            },
            headerAttributes: {style: 'white-space: normal'},
            filterable: true,
            sortable: true
        },
        {
            field: 'arAge31_60',
            title: 'AR 31-60',
            template(dataItem) {
                return kendoWindowTemplate(dataItem, 'arAge31_60', true);
            },
            headerAttributes: {style: 'white-space: normal'},
            filterable: true,
            sortable: true
        },
        {
            field: 'arAge61_90',
            title: 'AR 61-90',
            template(dataItem) {
                return kendoWindowTemplate(dataItem, 'arAge61_90', true);
            },
            headerAttributes: {style: 'white-space: normal'},
            filterable: true,
            sortable: true
        },
        {
            field: 'arAgeOver_90',
            title: 'AR Over 90',
            template(dataItem) {
                return kendoWindowTemplate(dataItem, 'arAgeOver_90', true);
            },
            headerAttributes: {style: 'white-space: normal'},
            filterable: true,
            sortable: true
        },
        {
            field: 'retainage',
            title: 'Retainage',
            template(dataItem) {
                return baseTemplate(dataItem, 'retainage');
            },
            headerAttributes: {style: 'white-space: normal'},
            filterable: true,
            sortable: true
        },
        {
            field: 'totalAged',
            title: 'Total Aged No Retainage',
            template(dataItem) {
                return baseTemplate(dataItem, 'totalAged');
            },
            headerAttributes: {style: 'white-space: normal'},
            filterable: true,
            sortable: true
        },
        {
            field: 'week1',
            title: '<temp>CurrentWeek</temp>',
            headerAttributes: {style: 'white-space: normal'},
            template(dataItem) {
                return kendoWindowTemplate(dataItem, 'week1', false)
            }
        },
        {
            field: 'week2',
            title: '<temp>Week2</temp>',
            headerAttributes: {style: 'white-space: normal'},
            template(dataItem) {
                return kendoWindowTemplate(dataItem, 'week2', false)
            }
        },
        {
            field: 'week3',
            title: '<temp>Week3</temp>',
            headerAttributes: {style: 'white-space: normal'},
            template(dataItem) {
                return kendoWindowTemplate(dataItem, 'week3', false)
            }
        },
        {
            field: 'week4',
            title: '<temp>Week4</temp>',
            headerAttributes: {style: 'white-space: normal'},
            template(dataItem) {
                return kendoWindowTemplate(dataItem, 'week4', false)
            }
        },
        {
            field: 'week5',
            title: '<temp>Week5</temp>',
            headerAttributes: {style: 'white-space: normal'},
            template(dataItem) {
                return kendoWindowTemplate(dataItem, 'week5', false)
            }
        },
        {
            field: 'future',
            title: '<temp>FutureWeek</temp>',
            headerAttributes: {style: 'white-space: normal'},
            template(dataItem) {
                return kendoWindowTemplate(dataItem, 'future', false)
            }
        }
    ]);

    $cashGrid.kendoGrid({
        columns,
        dataSource: {
            transport: {
                read: {
                    url: `/Account/Finance/GetCashCollectionList?company=${company}`,
                    type: 'POST',
                    dataType: 'json'
                }
            },
            requestEnd: bindToSource,
            pageSize: 20,
            schema: {
                model: {
                    fields: {
                        Contact: {type: 'string'},
                        company: {type: 'number'},
                        arAge0_30: {type: 'number'},
                        arAge31_60: {type: 'number'},
                        arAge61_90: {type: 'number'},
                        arAgeOver_90: {type: 'number'},
                        retainage: {type: 'number'},
                        totalAged: {type: 'number'},
                        week1: {type: 'number'},
                        week2: {type: 'number'},
                        week3: {type: 'number'},
                        week4: {type: 'number'},
                        week5: {type: 'number'},
                        future: {type: 'number'},
                        pmFirst: {type: 'string'},
                        pmLast: {type: 'string'},
                        pmName: {type: 'string'},
                        customerNum: {type: 'string'},
                        customerName: {type: 'string'},
                        invType: {type: 'string'}
                    }
                }
            }
        },
        resizable: false,
        mobile: false,
        scrollable: true,
        sortable: {
            mode: 'single',
            allowUnsort: true
        },
        filterable: {
            operators: {
                string: {
                    contains: 'Contains',
                    startswith: 'Starts with'
                }
            }
        },
        dataBound(e) {
            setWindowData();
            setHeaders(e);
            $('.icon.icon--comment').parents('td').css('position', 'relative');
            $('[role=gridcell]').has('[data-has-past=true]').addClass('bg-danger-light');
            placeVerticalDivision();
            addTooltips();
        },
        pageable: {
            alwaysVisible: false,
            pageSizes: true,
            buttonCount: 20
        }
    });
}

const createTotalsGrid = () => {
    const $totalGrid = allCompanies ? $('.grid.all-total-grid') : $('.grid.total-grid');
    const company = $totalGrid.data('company');
    let columns = [{
        field: 'row',
        title: 'Row',
        template(dataItem) {
            return '';
        },
        width: 60,
        headerAttributes: {style: 'white-space: normal'},
        filterable: false,
        sortable: false
    }];

    // If grid already created dont load again.
    if ($totalGrid.data('kendoGrid')) return;

    if (allCompanies) {
        columns.push({
            field: 'Company',
            title: 'Branch',
            width: 75,
            template(dataItem) {
                return '';
            },
            headerAttributes: {style: 'white-space: normal'},
            filterable: false,
            sortable: false
        })
    }

    columns = columns.concat([
        {
            field: 'Contract',
            title: 'Contract Number',
            template(dataItem) {
                if (dataItem.sortOrder === 0 || dataItem.sortOrder === 1) {
                    return dataItem.weekLabel
                }
                return "<span class='t-italic'>Change week over week</span>"
            },
            headerAttributes: {style: 'white-space: normal'}
        },
        {
            field: 'arAge0_30',
            title: 'Current AR (0-30 days)',
            template(dataItem) {
                return totalTemplate(dataItem, 'arAge0_30');
            },
            headerAttributes: {style: 'white-space: normal'}
        },
        {
            field: 'arAge31_60',
            title: 'AR 31-60',
            template(dataItem) {
                return totalTemplate(dataItem, 'arAge31_60');
            },
            headerAttributes: {style: 'white-space: normal'}
        },
        {
            field: 'arAge61_90',
            title: 'AR 61-90',
            template(dataItem) {
                return totalTemplate(dataItem, 'arAge61_90');
            },
            headerAttributes: {style: 'white-space: normal'}
        },
        {
            field: 'arAgeOver_90',
            title: 'AR Over 90',
            template(dataItem) {
                return totalTemplate(dataItem, 'arAgeOver_90');
            },
            headerAttributes: {style: 'white-space: normal'}
        },
        {
            field: 'retainage',
            title: 'Retainage',
            template(dataItem) {
                return totalTemplate(dataItem, 'retainage');
            },
            headerAttributes: {style: 'white-space: normal'}
        },
        {
            field: 'totalAged',
            title: 'Total Aged No Retainage',
            template(dataItem) {
                return totalTemplate(dataItem, 'totalAged');
            },
            headerAttributes: {style: 'white-space: normal'}
        },
        {
            field: 'week1',
            title: '<temp>CurrentWeek</temp>',
            template(dataItem) {
                return totalTemplate(dataItem, 'week1');
            },
            headerAttributes: {style: 'white-space: normal'},
            filterable: true,
            sortable: true
        },
        {
            field: 'week2',
            title: '<temp>Week2</temp>',
            template(dataItem) {
                return totalTemplate(dataItem, 'week2');
            },
            headerAttributes: {style: 'white-space: normal'},
            filterable: true
        },
        {
            field: 'week3',
            title: '<temp>Week3</temp>',
            template(dataItem) {
                return totalTemplate(dataItem, 'week3');
            },
            headerAttributes: {style: 'white-space: normal'},
            filterable: true
        },
        {
            field: 'week4',
            title: '<temp>Week4</temp>',
            template(dataItem) {
                return totalTemplate(dataItem, 'week4');
            },
            headerAttributes: {style: 'white-space: normal'},
            filterable: true
        },
        {
            field: 'week5',
            title: '<temp>Week5</temp>',
            template(dataItem) {
                return totalTemplate(dataItem, 'week5');
            },
            headerAttributes: {style: 'white-space: normal'},
            filterable: true
        },
        {
            field: 'future',
            title: '<temp>FutureWeek</temp>',
            template(dataItem) {
                return totalTemplate(dataItem, 'future');
            },
            headerAttributes: {style: 'white-space: normal'}
        }
    ])
    $totalGrid.kendoGrid({
        columns,
        dataSource: {
            transport: {
                read: {
                    url: `/Account/Finance/GetCashCollectionTotalList?company=${company}`,
                    type: 'POST',
                    dataType: 'json'
                }
            },
            pageSize: 3
        },
        resizable: false,
        mobile: false,
        scrollable: true,
        sortable: false,
        filterable: false,
        dataBound(e) {
            // Should always be the second element in the list;
            const data = e.sender._data[0];

            if (data) {
                const $collected = allCompanies ? $('.js-all-collected') : $('.js-collected');
                const $outstanding = allCompanies ? $('.js-all-outstanding') : $('.js-outstanding');

                if ($collected.length && $outstanding.length) {
                    $collected.text(kendo.format('{0:C0}', data.currentWeekCollected || 0)).parent().show();
                    $outstanding.text(kendo.format('{0:C0}', data.currentWeekOutstanding || 0)).parent().show();
                }
            }
            placeVerticalDivision();
        }
    });
}
const readGrids = () => {
    const $totalGrid = allCompanies ? $('.grid.all-total-grid') : $('.grid.total-grid');
    const $cashGrid = allCompanies ? $('.grid.all-cash-grid') : $('.grid.cash-grid');
    const k_totalGrid = $totalGrid.data('kendoGrid');
    const k_cashGrid = $cashGrid.data('kendoGrid');

    if (k_cashGrid) k_cashGrid.dataSource.read();
    if (k_totalGrid) k_totalGrid.dataSource.read();
}
const kendoWindowTemplate = (dataItem, weekId, isArAging = false) => {
    let weekDate = '';
    let hasComment = false;
    const value = dataItem[weekId];

    if (Object.keys(dataItem).length < 6) return value;

    switch (weekId) {
        case 'week1' : {
            weekDate = dataItem.w1Label.substring(12);
            hasComment = dataItem.w1HasComment !== 0
            break;
        }
        case 'week2' : {
            weekDate = dataItem.w2Label.substring(12);
            hasComment = dataItem.w2HasComment !== 0
            break;
        }
        case 'week3' : {
            weekDate = dataItem.w3Label.substring(12);
            hasComment = dataItem.w3HasComment !== 0
            break;
        }
        case 'week4' : {
            weekDate = dataItem.w4Label.substring(12);
            hasComment = dataItem.w4HasComment !== 0
            break;
        }
        case 'week5' : {
            weekDate = dataItem.w5Label.substring(12);
            hasComment = dataItem.w5HasComment !== 0
            break;
        }
        case 'future' : {
            weekDate = dataItem.futureLabel.substring(12);
            hasComment = dataItem.futureHasComment !== 0
            break;
        }
        default : {
            weekDate = weekId;
            hasComment = false;
        }
    }

    if (!dataItem.Contract && dataItem.invType !== 'Work Order/Agreement') {
        if (dataItem.sortOrder === 0) {
            dataItem.Contract = 'Current Week';
        } else if (dataItem.sortOrder === 1) {
            dataItem.Contract = 'Previous Week';
        } else {
            dataItem.Contract = 'Change week over week';
        }
    }

    const rowType = dataItem.invType?.toLowerCase();
    const customerContractNumber = rowType !== 'project' ? dataItem.Customer : dataItem.Contract.substring(0, 8)
    if (allCompanies) {
        return `<div style="text-align: center;" data-has-past="${dataItem.hasPast === 1 && weekId === 'week1'}"><p class="t-small-x">${kendo.format('{0:C0}', value)}</p>${hasComment ? `<span class="icon icon--comment" data-role="openKendoWindow" data-kendoWindow="invoiceComments" data-project-type="${rowType}" data-project-id="${customerContractNumber}" data-week-id="${weekDate}" data-cust-id="${dataItem.customerNum}" data-cust-name="${dataItem.customerName}" data-read-only=true style="position: absolute;  right:11px; top:7px;z-index: 1;"></span>` : ''}</div>`;
    }

    return `<div>
              ${hasComment ? `<span class="icon icon--comment" data-role="openKendoWindow" data-project-type="${rowType}" data-kendoWindow="invoiceComments" data-project-id="${customerContractNumber}" data-week-id="${weekDate}" data-cust-id="${dataItem.customerNum}" data-cust-name="${dataItem.customerName}" style="position: absolute; right:11px; top:7px;z-index: 1;"></span>` : ''}
            </div>
            <div style="position: relative; text-align: center;" data-has-past="${dataItem.hasPast === 1 && weekId === 'week1'}">
                <p class="t-small-x" data-kendoWindow="cashForecast" data-project-type="${rowType}" data-project-id="${customerContractNumber}" data-week-id="${weekDate}" data-cust-id="${dataItem.customerNum}" data-cust-name="${dataItem.customerName}" data-is-ar-aging="${isArAging}" data-role="openKendoWindow">${kendo.format('{0:C0}', value)}</p>
            </div>`;
};

const totalTemplate = (dataItem, field) => {
    if (dataItem.sortOrder === 0 || dataItem.sortOrder === 1) {
        return `<div style="text-align: center;">
                <p class="t-small-x">${kendo.format('{0:C0}', dataItem[field])}</p>
            </div>`;
    }
    return `<div style="text-align: center;">
                <p class="t-small-x t-italic">${kendo.format('{0:C0}', dataItem[field])}</p>
            </div>`;
}
const baseTemplate = (dataItem, field) => {
    return `<div style="text-align: center;">
                <p class="t-small-x">${kendo.format('{0:C0}', dataItem[field])}</p>
            </div>`;
}
const setHeaders = (e) => {
    const dataSet = e.sender._data[0];
    if (dataSet === undefined) return;
    const {w1Label} = dataSet;
    const {w2Label} = dataSet;
    const {w3Label} = dataSet;
    const {w4Label} = dataSet;
    const {w5Label} = dataSet;
    const {futureLabel} = dataSet;
    const $tempHeaders = $('temp');

    $.each($tempHeaders, function (index, ele) {
        const $self = $(ele);
        const innerText = $self.text().trim();

        switch (innerText) {
            case 'CurrentWeek' : {
                $self.parent().html(w1Label);
                break;
            }
            case 'Week2' : {
                $self.parent().html(w2Label);
                break;
            }
            case 'Week3' : {
                $self.parent().html(w3Label);
                break;
            }
            case 'Week4' : {
                $self.parent().html(w4Label);
                break;
            }
            case 'Week5' : {
                $self.parent().html(w5Label);
                break;
            }
            case 'FutureWeek' : {
                $self.parent().html(futureLabel);
                break;
            }
        }


        const {columns} = $('.cash-grid').data('kendoGrid');

        $.each(columns, function (index, item) {
            switch (item.field) {
                case 'week1' : {
                    item.title = w1Label;
                    break;
                }
                case 'week2' : {
                    item.title = w2Label;
                    break;
                }
                case 'week3' : {
                    item.title = w3Label;
                    break;
                }
                case 'week4' : {
                    item.title = w4Label;
                    break;
                }
                case 'week5' : {
                    item.title = w5Label;
                    break;
                }
                case 'future' : {
                    item.title = futureLabel;
                    break;
                }
            }
        });
    })
}
const saveInvoiceAssignment = () => {
    const $form = $('form#InvoiceAssignmentForm');

    if ($form.length) {
        const $saveButton = $form.find('[data-role=save]');

        if ($saveButton.length) {
            $saveButton.on('click', function (e) {
                e.preventDefault();
                $.post(`/Account/Finance/SaveCashInvoiceAssignment?${$form.serialize()}`, function (response) {
                    if (response) {
                        $('#cashForecast').data('kendoWindow').close();
                        // Reload grid
                        readGrids($('.menu-topbar__link.--active').text() === 'Full Company')
                    } else {
                        // Show Error Message
                        $('.js-error-msg').show();
                    }
                })
            });
        }
    }
}
const exportOptions = () => {
    const $exportSelect = $('#gridExport');

    if ($exportSelect.length) {
        $exportSelect.change(function () {
            // event.preventDefault();
            const {value} = this;
            $exportSelect.data('kendoDropDownList').select(0);
            if (value === '1') {
                exportToExcel();
            } else if (value === '2') {
                exportToCSV();
            }
        });

        let exportToExcel = function () {
            const $totalGrid = allCompanies ? $('.grid.all-total-grid') : $('.grid.total-grid');
            const $cashGrid = allCompanies ? $('.grid.all-cash-grid') : $('.grid.cash-grid');
            const k_totalGrid = $totalGrid.data('kendoGrid');
            const k_cashGrid = $cashGrid.data('kendoGrid');
            const dateTime = new Date();
            const {columns} = k_cashGrid;
            const totalData = Object.values(k_totalGrid.dataSource.data());
            const cashData = Object.values(k_cashGrid.dataSource.data());
            const combinedData = [totalData[0], totalData[1], totalData[2], {}];

            $('.js-export-grid').kendoGrid({
                columns,
                dataSource: combinedData.concat(cashData),
                excel: {
                    fileName: `CashCollectionForecastingExport_${dateTime.getFullYear()}${dateTime.getMonth() + 1}${dateTime.getDate()}.xlsx`,
                    filterable: true
                }
            }).data('kendoGrid').saveAsExcel();
        };
        let exportToCSV = function () {
            const $totalGrid = allCompanies ? $('.grid.all-total-grid') : $('.grid.total-grid');
            const $cashGrid = allCompanies ? $('.grid.all-cash-grid') : $('.grid.cash-grid');
            const k_totalGrid = $totalGrid.data('kendoGrid');
            const k_cashGrid = $cashGrid.data('kendoGrid');

            if (k_totalGrid && k_cashGrid) {
                const gridType = 'CashCollectionForecasting';
                const {columns} = k_cashGrid;
                const dataTotal = k_totalGrid.dataSource.data();
                const dataCash = k_cashGrid.dataSource.data();
                let csv = '';
                const dateTime = new Date();
                const fileName = `${gridType}Export_${dateTime.getFullYear()}${dateTime.getMonth() + 1}${dateTime.getDate()}.csv`;

                // Add Columns
                $.each(columns, function (index, item) {
                    const field = item.title || item.field;
                    if (field) {
                        csv += `${field},`;
                    }
                });

                csv += '\n';

                // Add Totals Grid
                $.each(dataTotal, function (index, item) {
                    columns.forEach(function (ele) {
                        const {field} = ele;
                        if (field) {
                            if (field === 'Contract') {
                                switch (item.sortOrder) {
                                    case 0: {
                                        csv += 'CurrentWeek,';
                                        break;
                                    }
                                    case 1: {
                                        csv += 'PreviousWeek,';
                                        break;
                                    }
                                    default:
                                        csv += 'Change week over week,';
                                        break;
                                }
                            } else {
                                csv += `${item[ele.field] || '0.00'},`;
                            }
                        }
                    });
                    csv += '\n';
                });

                // Insert blank row between sets
                columns.forEach(function (ele) {
                    csv += ',';
                });
                csv += '\n';

                // Add Cash Grid
                $.each(dataCash, function (index, item) {
                    columns.forEach(function (ele) {
                        const {field} = ele;
                        if (field) {
                            csv += `${item[ele.field] || '0.00'},`;
                        }
                    });
                    csv += '\n';
                });

                if (navigator.msSaveBlob) {
                    // IE 10+
                    navigator.msSaveBlob(new Blob([csv], {type: 'text/csv;charset=utf-8;'}), fileName);
                } else {
                    const encodedUri = `data:text/csv;charset=utf-8,${escape(csv)}`;
                    const link = document.createElement('a');
                    link.setAttribute('href', encodedUri);
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }
        };
    }
}
const scrollBackToTop = () => {
    const $backToTopButton = $('.js-back-to-top');
    // $scrollSection = allCompanies ? $('.js-all-cash-scroll') : $('.js-cash-scroll'),
    const $scrollSection = $(document);
    const scrollButtonToggle = function () {
        if ($scrollSection.scrollTop() > 400) {
            $backToTopButton.show();
        } else {
            $backToTopButton.hide();
        }
    };

    // Set for tab change
    scrollButtonToggle();

    // Attach Button Event
    if ($backToTopButton.length) {
        $backToTopButton.unbind('click');
        $backToTopButton.on('click', function () {
            $scrollSection.scrollTop(0);
            $backToTopButton.hide();
        })
    }

    // Attach Scroll Event
    $scrollSection.unbind('scroll');
    $scrollSection.on('scroll', function (e) {
        scrollButtonToggle();
    });
}
const placeVerticalDivision = () => {
    $('[data-field="totalAged"]').attr('style', 'border-right: 2px solid #CCCCCC')
}

const populateCashReceivedGrid = () => {
    const $totalGrid = allCompanies ? $('.grid.all-total-grid') : $('.grid.total-grid');
    const company = $totalGrid.data('company');
    const dateTime = new Date();
    const fileName = `CashCollectionReceived${dateTime.getFullYear()}${dateTime.getMonth() + 1}${dateTime.getDate()}.xlsx`;
    const dateFormat = '{0: yyyy-MM-dd}';
    const columns = [{
        field: 'Contract',
        title: 'Contract',
        headerAttributes: {style: 'white-space: normal'},
        filterable: false,
        sortable: false
    },
        {
            field: 'CustName',
            title: 'CustomerName',
            headerAttributes: {style: 'white-space: normal'},
            filterable: false,
            sortable: false
        },
        {
            field: 'Invoice',
            title: 'Invoice',
            headerAttributes: {style: 'white-space: normal'},
            filterable: false,
            sortable: true
        },
        {
            field: 'InvoiceDate',
            title: 'Invoice Date',
            template(data) {
                if (data.InvoiceDate) {
                    return kendo.toString(kendo.parseDate(data.InvoiceDate), 'yyyy-MM-dd');
                }
                return '-';
            },
            headerAttributes: {style: 'white-space: normal'},
            filterable: false,
            sortable: true
        },
        {
            field: 'InvoiceAmt',
            title: 'Invoice Amount',
            template(data) {
                if (data.InvoiceAmt) {
                    return kendo.toString(data.InvoiceAmt, 'c2');
                }
                return '-';
            },
            headerAttributes: {style: 'white-space: normal'},
            filterable: false,
            sortable: true
        },
        {
            field: 'LastAnticipatedDate',
            title: 'Last Anticipated Date',
            template(data) {
                if (data.LastAnticipatedDate) {
                    return kendo.toString(kendo.parseDate(data.LastAnticipatedDate), 'yyyy-MM-dd');
                }
                return '-';
            },
            headerAttributes: {style: 'white-space: normal'},
            filterable: false,
            sortable: true
        },
        {
            field: 'DepositDate',
            title: 'Deposit Date',
            template(data) {
                if (data.DepositDate) {
                    return kendo.toString(kendo.parseDate(data.DepositDate), 'yyyy-MM-dd');
                }
                return '-';
            },
            headerAttributes: {style: 'white-space: normal'},
            filterable: false,
            sortable: true
        },
        {
            field: 'DBO',
            title: 'DBO',
            headerAttributes: {style: 'white-space: normal'},
            filterable: false,
            sortable: true
        }];

    const $cashCollection = $('#cashCollectionReceived');
    const $cashCollectionWindow = $cashCollection.parents('.k-window');

    $cashCollection.kendoGrid({
        columns,
        dataSource: {
            transport: {
                read: {
                    url: `/Account/Finance/GetCashCollectionReceived?company=${company}`,
                    type: 'POST',
                    dataType: 'json'
                }
            },
            pageSize: 10
        },
        resizable: true,
        mobile: false,
        scrollable: true,
        sortable: true,
        filterable: {
            mode: 'menu',
            extra: false,
            operators: {
                string: {
                    contains: 'Contain',
                    doesnotcontain: 'Do not contain'
                }
            }
        },
        toolbar: kendo.template('<input id="export" style="float:right;" />'), excel: {
            fileName, filterable: true
        },
        dataBound(e) {
        },
        pageable: {
            alwaysVisible: true,
            pageSizes: true,
            buttonCount: 20
        }
    })

    $cashCollectionWindow.css('width', '90vw');
    $cashCollectionWindow.css('max-width', '90vw');

    // Add Grid Export Functionality
    gridExport();
}
